/*!
 * KoliBri - The accessible HTML-Standard
 */
let openTooltips = 0;
const tooltipOpened = () => {
    openTooltips++;
};
const tooltipClosed = () => {
    openTooltips = Math.max(0, openTooltips - 1);
};
const handleCancelOverlay = (event) => {
    if (openTooltips > 0) {
        event.preventDefault();
    }
};
const isTooltipOpen = () => openTooltips > 0;

export { tooltipOpened as a, handleCancelOverlay as h, isTooltipOpen as i, tooltipClosed as t };
//# sourceMappingURL=tooltip-open-tracking-D3tCiiGP.js.map

//# sourceMappingURL=tooltip-open-tracking-D3tCiiGP.js.map